export default "__VITE_ASSET__C$rqf14F__"